import { TESTIMONIALS, CONTACT, TESTIMONIALS_PAGE } from "../../data/site";
import { Reveal, SectionHeading } from "./Reveal";

export const Testimonials = () => (
  <section data-testid="testimonials-section" className="max-w-[1400px] mx-auto px-6 lg:px-10 py-24 lg:py-32">
    <SectionHeading number="04" kicker={`Rated ${CONTACT.rating} from ${CONTACT.reviews} reviews`} title={TESTIMONIALS_PAGE.title} />
    <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-white/10">
      {TESTIMONIALS.map((t, i) => (
        <Reveal key={t.name + i} delay={i * 0.12} className="bg-[#050A15] p-10 flex flex-col justify-between min-h-[320px]">
          <p className="text-white/70 leading-relaxed text-[15px]">“{t.quote}”</p>
          <div className="mt-8 pt-6 border-t hairline border-t-white/10">
            <p className="font-display font-medium text-white">{t.name}</p>
            <p className="font-mono-x text-[10px] tracking-[0.25em] uppercase text-white/40 mt-1">{t.place}</p>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);
